<template title="'速派大咖申请'">
    <div class="expert-submit">
        <div v-if="isShow">
            <div class="nth-item">
                <h3>请用一段话描述您自己</h3>
                <van-field
                    v-model="expertdesc"
                    rows="2"
                    autosize
                    type="textarea"
                    placeholder="该描述将展示给所有速派用户，请认真填写并注意隐私安全"
                    show-word-limit
                    class="textarea"
                    maxlength="250"
                />
            </div>
            <div class="sticky-card">
                <div class="expert-sign">
                    <button @click="clickApply">确认申请</button>
                </div>
            </div>
        </div>
        <div class="nth-items" v-if="!isShow">
            申请已提交！请耐心等候速派联系
            <div class="sticky-card" style="position: fixed;left: 0;width: 100%">
                <div class="expert-sign">
                    <button @click="$router.go(-1)">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {
    expertApply, // 申请大咖审核
} from '@/common/api.js'
export default {
    data() {
        return {
            isShow: true,
            expertdesc: '',
        }
    },
    methods:{
        // 点击申请
        clickApply(){
            if(!this.expertdesc) {
                return this.$notify('请输入描述！');
            }
            let data = {}
            data.expertdesc = this.expertdesc
            data.applystatus = 1
            data.userid = this.$route.query.userid
            expertApply(data).then(res=> {
                if(res.Result == 1) {
                    this.isShow = false
                }
            })
        },
    },
}
</script>
<style lang="scss">
    @import '~@/style/_base.scss';
    .expert-submit {
        min-height: 100vh;
        background: #ffffffff;
        .nth-item {
            min-height: 100vh;
            padding: px2rem(30px) px2rem(32px);
            h3 {
                font-size: px2rem(30px);
                color: #333333;
                font-weight: bold;
                line-height: px2rem(100px);
            }
            .textarea {
                background: transparent;
                border-bottom: 1px solid #E5E5E5;
                padding-left: 0;
                padding-right: 0;
                textarea {
                    font-size: px2rem(28px);
                }
            }
        }
        .sticky-card {
            position: sticky;
            bottom: 0;
            padding-bottom: 20px;
            box-shadow: 0px -6px 10px 0px rgba(0, 0, 0, 0.06);
            padding-left: px2rem(28px);
            padding-right: px2rem(28px);
            min-height: px2rem(170px);
            background: #ffffff;
            .expert-sign {
                padding: px2rem(48px) px2rem(22px) 0;
                > button {
                    display: block;
                    width: 100%;
                    height: px2rem(88px);
                    background: #f75959;
                    border-radius: px2rem(44px);
                    font-size: px2rem(30px);
                    color: #ffffff;
                }
            }
        }
        .nth-items {
            min-height: inherit;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: px2rem(30px);
            color: #333333;
        }
    }
</style>